/** Credora brand logo assets */
import brandLogo from "../images/logo/credo.png";
import favicon from "../images/logo/favicon.png";

export const logoLight = brandLogo;
export const logoDark = brandLogo;
export const logoIcon = brandLogo;
export { brandLogo, favicon };
